import React, { FC } from 'react';
import { useTranslation } from '@wix/fe-essentials-standalone';
import {
  MODAL_ACTIONS,
  useModalsContext,
} from '@components/Contexts/ModalsContext';
import StatusToastNotification from '@components/StatusToastNotification';

type ToastNotificationProps = {
  isMobileView: boolean;
};
const ToastNotification: FC<ToastNotificationProps> = ({ isMobileView }) => {
  const { t } = useTranslation();
  const { dispatchModal, toast } = useModalsContext();

  return (
    <StatusToastNotification
      show={toast.show}
      isMobileView={isMobileView}
      key="toast-notification"
      status={toast.status}
      dismissible
      duration={5000}
      dataHook="toast-notification"
      onDismiss={() => {
        dispatchModal({
          type: MODAL_ACTIONS.HIDE_TOAST,
        });
      }}
      message={t(toast.message)}
    />
  );
};

export default ToastNotification;
